import type { ApiFiltersResult } from "@modules/types"
import { isPC } from "@modules/util/device.ts"
import { dispatchGlobalEvent } from "@modules/util/events"
import { updateLinks } from "@modules/util/update-links"
import { updateUrl } from "@modules/util/url"
import { updateAdvertCardContainerUI, updateAdvertResultsFoundInfoInDom } from "../global/advert-card-container.ts"
import { advertNewsCardsContainerElement, advertTelephoneCardsContainerElement } from "../global/dom.ts"
import { getNextPage, setPagination, updatePaginationButtons, updatePaginationSelect } from "./pagination/pagination"

export function removeSamePageContent() {
    if (isPC()) {
        const container = advertNewsCardsContainerElement()
        if (container) {
            container.innerHTML = ""
        }
        return
    }
    const pageStartElement = advertNewsCardsContainerElement()?.querySelector(`#page-section-${getNextPage() - 1}`)
    let nextElement = pageStartElement?.nextElementSibling
    while (continueRemovingSamePageElement(nextElement)) {
        const oldEl = nextElement
        nextElement = nextElement?.nextElementSibling
        oldEl?.remove()
    }
    pageStartElement?.remove()
}

export function continueRemovingSamePageElement(el: Element | null | undefined) {
    if (!el) {
        return false
    }
    return !el.id.includes("page-section")
}

export async function afterApiFetched(
    filterApiResult: ApiFiltersResult | undefined,
    options: { insertAdjacentHTML?: InsertPosition; removeSamePageContent?: boolean } = {},
) {
    if (!filterApiResult) {
        return
    }
    dispatchGlobalEvent("telephonesex.filter-api.after-fetch", filterApiResult)
    const advertCardsContainerEl = advertTelephoneCardsContainerElement()
    if (advertCardsContainerEl) {
        await new Promise((resolve) =>
            requestAnimationFrame(() => {
                if (options.removeSamePageContent) {
                    removeSamePageContent()
                }
                if (options.insertAdjacentHTML) {
                    advertCardsContainerEl.insertAdjacentHTML(options.insertAdjacentHTML, filterApiResult.content)
                } else {
                    advertCardsContainerEl.innerHTML = filterApiResult.content
                }
                resolve(null)
            }),
        )
    }

    updateAdvertCardContainerUI(filterApiResult.advertCount) //TODO ??
    updateUrl(filterApiResult.seoUrl)
    setPagination(filterApiResult.pagination)
    updatePaginationButtons(filterApiResult.pagination)
    updatePaginationSelect(filterApiResult.pagination)
    updateAdvertResultsFoundInfoInDom(filterApiResult)
    updateLinks()

    SiteInfo.endsWithLastAdvertInGroup = filterApiResult.endsWithLastAdvertInGroup || false
    SiteInfo.currentSearchHash = filterApiResult.currentSearchHash || ""
}
